<template>
  <!-- 购物车底部 -->
  <div>
    <van-row class="fvlr">
      <van-col span="6" class="selectAll" v-if="false">
        <van-checkbox v-model="allGoods" @click="checkAllGoods" shape="square" checked-color="#3088c5">全选 </van-checkbox>
      </van-col>
      <van-col span="24">
        <van-row class=" deleteBox" v-if="isManage">
          <div class="delete" @click="deleteSelectFn">
            <img src="../../assets/images/delete.png" class="iconImg" />
            <span>删除</span>
          </div>
        </van-row>
        <van-row class="fvlr" v-else>
          <van-col span="14">
            <div class="fhr">
              <van-row class="totalPriceRow">
                {{ totalLable }}：<span class="price">¥{{ totalPrice }}</span>
              </van-row>
              <van-row class="discountRow" v-if="isShowDiscount && discountAmount">
                优惠减:<span class="discountMount">{{ `¥${discountAmount ? discountAmount : '0'} ` }}</span
                ><span @click.stop="showDiscountDetail">优惠明细</span>
              </van-row>
            </div>
          </van-col>
          <van-col span="10">
            <div class="balance" @click="toBalance">
              去购买<span v-if="isShowTotalAmount">({{ totalProductAmount }})</span>
            </div>
          </van-col>
        </van-row>
      </van-col>
    </van-row>
    <DiscountUseDetail :datas="{ totalPrice, couponListData, tyreSelectedList }" :showPopUp="showDiscountNum" @click-coupon="clickCoupon"></DiscountUseDetail>
  </div>
</template>

<script>
import { reactive, toRefs, watch, nextTick, computed } from 'vue'
import DiscountUseDetail from '@/components/shoppingCart/DiscountUseDetail'
import { getTyreCouponList } from '@/api/shoppingCar'
import { couponList } from '@/util/plan'
import { showToast } from '@/util/couponCollection'

export default {
  props: {
    currentType: {
      type: String,
      default: ''
    },
    selectAllGoods: {
      type: Boolean,
      default: false
    },
    isManage: {
      type: Boolean,
      default: false
    },
    isShowDiscount: {
      type: Boolean,
      default: false
    },
    totalPrice: {
      type: Number,
      default: 0
    },
    totalProductAmount: {
      type: Number,
      default: 0
    },
    couponListParam: {
      type: Object,
      default: null
    },
    tyreSelectedList: {
      type: Array,
      default: () => []
    }
  },
  components: {
    DiscountUseDetail
  },
  emits: ['check-all-goods', 'delete', 'to-balance'],
  setup(props, { emit }) {
    let { currentType, selectAllGoods, isManage, isShowDiscount, totalPrice, totalProductAmount, couponListParam, tyreSelectedList } = toRefs(props)
    const state = reactive({
      currentType,
      allGoods: selectAllGoods,
      isManage,
      isShowDiscount,
      totalPrice,
      totalProductAmount,
      couponListParam,
      tyreSelectedList,
      couponListData: [],
      discountAmount: 0,
      showDiscountNum: 0,
      selectedDiscount: null,
      isShowTotalAmount: true,
      notUseCoupon: false
    })
    const checkAllGoods = () => {
      emit('check-all-goods', { value: state.allGoods })
    }
    const deleteSelectFn = () => {
      emit('delete')
    }
    const toBalance = () => {
      let data = state.selectedDiscount?.selectCouponArr || []
      emit('to-balance', { data, notUseCoupon: state.notUseCoupon })
    }

    // 获取轮胎结算中的可用优惠券列表
    const getTyreCouponListFn = async param => {
      if (state.couponListParam && state.isShowDiscount) {
        param = param || state.couponListParam
        try {
          const { list = [] } = await getTyreCouponList(param)
          const data = couponList(list.map(item => ({ ...item.coupon, ...item })))
          state.couponListData = [...data]
        } catch (e) {
          state.couponListData = []
        }
      } else {
        state.couponListData = []
      }
    }
    // 展示优惠明细
    const showDiscountDetail = async () => {
      if (state.couponListParam && state.isShowDiscount) {
        try {
          // 展开的时候刷新数据
          // await getTyreCouponListFn();
          state.showDiscountNum += 1
        } catch (e) {
          showToast(e.message, '获取优惠券明细失败')
          state.couponListData = []
        }
      } else {
        showToast('请选择要结算的轮胎')
        state.couponListData = []
      }
    }
    const clickCoupon = data => {
      state.discountAmount = data?.discountAmount || 0
      state.selectedDiscount = data
      state.notUseCoupon = data.notUseCoupon
    }
    watch(
      () => state.totalProductAmount,
      () => {
        state.isShowTotalAmount = false
        nextTick(() => {
          state.isShowTotalAmount = true
        })
      }
    )
    watch(
      () => state.couponListParam,
      () => {
        nextTick(() => {
          getTyreCouponListFn()
        })
      }
    )
    const totalLable = computed(() => {
      if (state.currentType === 'shop') {
        return '零售价合计'
      }
      if (state.currentType === 'plan') {
        return '合计金额'
      }
      return '厂商建议零售价合计'
    })

    return {
      ...toRefs(state),
      checkAllGoods,
      deleteSelectFn,
      toBalance,
      showDiscountDetail,
      clickCoupon,
      totalLable
    }
  }
}
</script>
<style lang="scss" scoped>
.price {
  font-weight: 600;
  font-size: 14px;
  color: #3088c5;
}
.balance {
  color: #fff;
  background-color: #3088c5;
}
.deleteBox {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  height: 48px;
  line-height: 48px;
}
.delete {
  width: 80px;
  height: 32px;
  margin: 8px 20px 8px 0;
  color: #3088c5;
  line-height: 32px;
  font-size: 14px;
  border: solid 0.5px #3088c5;
  vertical-align: middle;
  span,
  .iconImg {
    vertical-align: middle;
  }
}
.iconImg {
  width: 14px;
  height: 18px;
  margin-right: 3px;
}
.totalPriceRow {
  padding-right: 16px;
  font-size: 12px;
  color: #666666;
  line-height: 16px;
}
.discountRow {
  padding-right: 16px;
  margin-top: 4px;
  font-size: 12px;
  color: #666666;
  line-height: 12px;
}
.discountMount {
  margin: 0 6px;
  color: #c30000;
}
</style>
